import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import PhoneInput from "react-phone-number-input";
import { useSelector } from "react-redux";
import styles from "../styles/adminBrandsComponent.module.css";
import btnStyles from "../styles/globalButtonStylng.module.css";
import { AdminInstance } from "../utils/adminClass";
import { UsStateInstance } from "../utils/usStateClass";
import { ImageScaleAndCropComponent } from "./imageScaleAndCropComponent";

export const AdminAddVenueFormComponent = ({
  closeForm,
  data,
  setInputs,
  editing = false,
  setReset,
}: {
  closeForm: Function;
  data: any;
  setInputs: any;
  editing: Boolean;
  setReset: Function;
}) => {
  const { states, isLoading } = useSelector((state: any) => state.state);
  const [venueDetails, setVenueDetails] = useState<Record<string, any>>({
    type: "",
    state: {},
    dispensaryType: null,
  }); //default to Nevada for now which is 28
  const [canSubmit, setCanSubmit] = useState<Boolean>(false);
  const [phoneNumber, setPhoneNumber] = useState<any>("");
  const requiredFields = [
    "name",
    "phoneNumber",
    "website",
    "state",
    "city",
    "street",
    "zip",
    // "licenseNumber",
    "type",
    // if type is dispensary then dispensaryType is required
    ...(venueDetails.type === "dispensary" ? ["dispensaryType"] : []),
  ];

  //for adding images
  const [selectedThumbnail, setSelectedThumbnail] = useState<File | null>(null);
  const [selectedDisplayImage, setSelectedDisplayImage] = useState<File | null>(null);
  const [isCropVisible, setIsCropVisible] = useState<{
    thumb: boolean;
    display: boolean;
  }>({
    thumb: false,
    display: false,
  });

  const [imageSrc, setImageSrc] = useState<{
    thumb: string | null;
    display: string | null;
  }>({
    thumb: null,
    display: null,
  });

  useEffect(() => {
    const fetchStatesAndSetInitial = async () => {
      await UsStateInstance.getUsStates();
      // Check if states are loaded and set a default value safely
      if (states.length > 0) {
        setVenueDetails((prevDetails) => ({
          ...prevDetails,
          state: states[27] || {}, // Safe fallback if states[27] doesn't exist
        }));
      }
      if (data.phoneNumber) {
        setPhoneNumber(data.phoneNumber);
      }
    };
    fetchStatesAndSetInitial();
  }, []);

  useEffect(() => {
    setVenueDetails({
      ...venueDetails,
      phoneNumber: phoneNumber,
    });
  }, [phoneNumber]);

  useEffect(() => {
    const isFilled = requiredFields.every((field) => venueDetails[field]);
    setCanSubmit(isFilled || editing);
    console.log("here be the venu blob", venueDetails);
  }, [venueDetails]);

  //when we have data from updating our venue
  useEffect(() => {
    UsStateInstance.getUsStates();
    console.log("DATA", data);
    if (data) {
      setVenueDetails({
        ...venueDetails,
        ...data,
      });
      setPhoneNumber(venueDetails.phoneNumber);
      setImageSrc((prev) => ({ ...prev, display: data.displayUrl }));
      setImageSrc((prev) => ({ ...prev, thumb: data.avatarUrl }));
    }
    console.log("Venue DETAILS IS NOW", venueDetails);
  }, [data]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setVenueDetails({
      ...venueDetails,
      [name]: value,
    });
  };

  const handleImageCropped = async (croppedImageUrl: string, type: "thumb" | "display") => {
    // Convert the cropped image URL to a Blob
    const response = await fetch(croppedImageUrl);
    const blob = await response.blob();
    console.log("HERE BE OUR BLOB", blob);
    // Create a File object from the Blob
    const fileExt = blob.type.split("/")[1]; // Extracts the file extension from the MIME type
    const fileName = `cropped_image.${fileExt}`; // Constructs a file name
    const croppedImageFile = new File([blob], fileName, { type: blob.type });
    // Generate a URL for the cropped image file
    const croppedImageURL = URL.createObjectURL(croppedImageFile);
    console.log("HERE BE THE IMAGE FILE", croppedImageFile);
    console.log("IMAGE URL BE HERE", croppedImageURL);

    // Update the appropriate state with the new File object
    if (type === "thumb") {
      setSelectedThumbnail(croppedImageFile);
      setImageSrc((prev) => ({ ...prev, thumb: croppedImageURL }));
    } else if (type === "display") {
      setSelectedDisplayImage(croppedImageFile);
      setImageSrc((prev) => ({ ...prev, display: croppedImageURL }));
    }

    // Hide the cropping modal
    setIsCropVisible((prev) => ({ ...prev, [type]: false }));
    return;
  };

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>, type: "thumb" | "display") => {
    const file = event.target.files ? event.target.files[0] : null;
    console.log("HERE BE DEH FILE", file);
    if (file) {
      const fileURL = URL.createObjectURL(file);
      if (type === "thumb") {
        setSelectedThumbnail(file);
      } else {
        setSelectedDisplayImage(file);
      }
      setImageSrc((prev) => ({ ...prev, [type]: fileURL }));
      setIsCropVisible((prev) => ({ ...prev, [type]: true }));
    }
  };

  const handleDisplayImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleImageChange(event, "display");
  };

  const handleThumbnailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleImageChange(event, "thumb");
  };

  const handleForm = async (e: any) => {
    e.preventDefault();
    try {
      console.log('venue being added"', venueDetails);
      if (editing) {
        //adding in image updates to our brandDetails;
        const withImages = {
          ...venueDetails,
          displayImg: selectedDisplayImage,
          avatarImg: selectedThumbnail,
        };
        console.log("here be updated deets with images", withImages);
        const updatedVenue = await AdminInstance.updateVenue(venueDetails.id, withImages, venueDetails.name);
        console.log("here be updated venue", updatedVenue);
        //await AdminInstance.updateBrand(brandDetails.id, brandDetails, brandDetails.name);
      } else {
        console.log("here be the venue", venueDetails);
        const newVenue = await AdminInstance.addVenueToDB({
          name: venueDetails.name,
          type: venueDetails.type,
          dispensaryType: venueDetails.dispensaryType,
          stateId: venueDetails.stateId,
          website: venueDetails.website,
          city: venueDetails.city,
          street: venueDetails.street,
          licenseNumber: venueDetails.licenseNumber,
          phoneNumber: venueDetails.phoneNumber,
          displayImg: selectedDisplayImage,
          avatarImg: selectedThumbnail,
          zip: venueDetails.zip,
        });
        console.log("HERE BE NEW VENUE", newVenue);
      }
      setReset();
    } catch (error) {
      console.log(`failed form submission with error: ${error}`);
      console.error(error);
    }
  };

  return (
    <Form className={styles.wrapper} id="addVenueForm">
      <Form.Group className="mb-3" controlId="formBasicName">
        {/* select venue type */}
        <Form.Label>Venue Type</Form.Label>
        <div>
          <select
            name="type"
            id=""
            defaultValue={venueDetails.type}
            onChange={(e) =>
              setVenueDetails({
                ...venueDetails,
                type: e.target.value,
              })
            }
          >
            <option value=""></option>
            <option value="dispensary" selected={venueDetails.type === "dispensary"}>
              dispensary
            </option>
            <option value="smokeshop" selected={venueDetails.type === "smokeshop"}>
              smoke shop
            </option>
          </select>
        </div>
        {/* if the venue type is dispensary then select a dispensary type */}
        {venueDetails.type === "dispensary" && (
          <Form.Group className="mb-3" controlId="formBasicDispensaryType">
            <Form.Label>Dispensary Type</Form.Label>
            <div>
              <select
                name="dispensaryType"
                id=""
                defaultValue={venueDetails.dispensaryType}
                onChange={(e) =>
                  setVenueDetails({
                    ...venueDetails,
                    dispensaryType: e.target.value,
                  })
                }
              >
                <option value=""></option>
                <option value="recreational" selected={venueDetails.type === "recreational"}>
                  recreational
                </option>
                <option value="medical" selected={venueDetails.type === "medical"}>
                  medical
                </option>
                <option value="both" selected={venueDetails.type === "both"}>
                  both
                </option>
              </select>
            </div>
          </Form.Group>
        )}

        <Form.Label>Venue Name</Form.Label>
        <Form.Control
          type="text"
          name="name"
          placeholder="Venue Name"
          onChange={handleInputChange}
          value={venueDetails.name}
        />
      </Form.Group>

      <Form.Group className="mb-3" controlId="formBasicURL">
        <Form.Label>Website URL</Form.Label>
        <Form.Control
          type="url"
          name="website"
          placeholder="Enter website URL"
          onChange={handleInputChange}
          value={venueDetails.website}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Display Image (optional)</Form.Label>
        <div className={styles.thumbnailWrapper}>
          <>
            {isCropVisible.display && (
              <ImageScaleAndCropComponent
                setSrc={(croppedImgUrl: any) => {
                  handleImageCropped(croppedImgUrl, "display");
                  //handleImageCropped(croppedImgUrl, 'thumb');
                }}
                imageType="displayImage"
                src={imageSrc.display}
                handleClose={() => setIsCropVisible((prev) => ({ ...prev, display: false }))}
              />
            )}
          </>
          <div
            style={{
              margin: "0 auto 10px auto",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {imageSrc.display ? (
              <img
                src={
                  imageSrc.display
                    ? imageSrc.display
                    : selectedDisplayImage
                      ? URL.createObjectURL(selectedDisplayImage)
                      : "https://via.placeholder.com/150"
                }
                alt="display image"
              />
            ) : (
              <div className={styles.imagePlaceHolder}>
                <h3>1080 x 1080</h3>
              </div>
            )}
          </div>
          <input type="file" onChange={handleDisplayImageChange} accept="image/png, image/jpeg, image/jpg" />
          <p>
            Set the Brand Display image. Please select an image that is 1080 x 1080. Only *.png, *.jpg and *.jpeg image
            files are accepted
          </p>
        </div>
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Avatar Image (optional)</Form.Label>
        <div className={styles.thumbnailWrapper}>
          <>
            {isCropVisible.thumb && (
              <ImageScaleAndCropComponent
                setSrc={(croppedImgUrl: any) => {
                  //handleImageCropped(croppedImgUrl, 'display');
                  handleImageCropped(croppedImgUrl, "thumb");
                }}
                imageType="avatar"
                src={imageSrc.thumb}
                handleClose={() => setIsCropVisible((prev) => ({ ...prev, thumb: false }))}
              />
            )}
          </>
          <div
            style={{
              margin: "0 auto 10px auto",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {imageSrc.thumb ? (
              <img
                src={
                  imageSrc.thumb
                    ? imageSrc.thumb
                    : selectedThumbnail
                      ? URL.createObjectURL(selectedThumbnail)
                      : "https://via.placeholder.com/150"
                }
                alt="avatar image"
              />
            ) : (
              <div className={styles.imagePlaceHolder}>
                <h3>600 x 600</h3>
              </div>
            )}
          </div>
          <input type="file" onChange={handleThumbnailChange} accept="image/png, image/jpeg, image/jpg" />
          <p>
            Set the Brand Avatar image. Please select an image that is 600 x 600. Only *.png, *.jpg and *.jpeg image
            files are accepted
          </p>
        </div>
      </Form.Group>
      <Form.Group className="mb-3" controlId="formBasicStreet">
        <Form.Label>Street</Form.Label>
        <Form.Control
          type="text"
          name="street"
          placeholder="Street Address"
          onChange={handleInputChange}
          value={venueDetails.street}
        />
      </Form.Group>
      <Form.Group className="mb-3" controlId="formBasicCity">
        <Form.Label>City</Form.Label>
        <Form.Control
          type="text"
          name="city"
          placeholder="City"
          onChange={handleInputChange}
          value={venueDetails.city}
        />
      </Form.Group>
      <div className="row">
        <Form.Group className="mb-3 col" controlId="formBasicState">
          <Form.Label>State</Form.Label>
          <div>
            <select
              //defaultValue={venueDetails?.state?.id || ''}
              value={venueDetails.stateId}
              name="state"
              onChange={(e) => {
                const selectedStateId = parseInt(e.target.value, 10);
                const selectedState = states.find((state: any) => state.id === selectedStateId);
                setVenueDetails((prevDetails) => ({
                  ...prevDetails,
                  stateId: selectedState.id || {},
                  state: selectedState || {},
                }));
              }}
            >
              <option value=""></option>
              {states.map((state: any) => (
                <option key={state.id} value={state.id}>
                  {state.label}
                </option>
              ))}
            </select>
          </div>
        </Form.Group>
        <Form.Group className="mb-3 col" controlId="formBasicZip">
          <Form.Label>ZIP</Form.Label>
          <Form.Control
            type="text"
            name="zip"
            placeholder="ZIP"
            onChange={handleInputChange}
            value={venueDetails.zip}
          />
        </Form.Group>
      </div>
      <div className="row">
        <Form.Group className="mb-3 col" controlId="formBasicPhone">
          <Form.Label>Phone Number</Form.Label>
          <PhoneInput
            countrySelectProps={{ unicodeFlags: true }}
            // remove the country select
            countrySelectComponent={({ value, flags, onSelect }) => {
              return (
                <div>
                  <span></span>
                </div>
              );
            }}
            country="US"
            defaultCountry="US"
            placeholder="Phone Number"
            value={phoneNumber || ""}
            onChange={setPhoneNumber}
          />
        </Form.Group>
        <Form.Group className="mb-3 col" controlId="formBasicLicense">
          <Form.Label>Business License</Form.Label>
          <Form.Control
            type="text"
            name="licenseNumber"
            placeholder="Business License Number"
            onChange={handleInputChange}
            value={venueDetails.licenseNumber}
          />
        </Form.Group>
      </div>
      <Button className={btnStyles.Submit} disabled={!canSubmit} variant="primary" type="submit" onClick={handleForm}>
        {editing ? "Update Venue" : "Create Venue"}
      </Button>
    </Form>
  );
};
